module.exports = __webpack_public_path__ + "no-data-gray.svg";